import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { func } from 'prop-types';
import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import PaymentResult from '../PaymentResult';

const PaymentResultContainer = (props) => {
  const {
    confirmationMessage,
    confirmationDescription,
    locale,
    orderReviewModel,
    widgetNameSpace,
  } = useSelector(state => state.propsData);
  const {
    isPaymentProcessingFeeModel: isPPF,
  } = useSelector(state => state.paymentOptions || {});
  const { trackingCallback, showFullInfoPaymentResult } = props;
  const { entities: { orderInfo, orderPaymentResult } } = useSelector(state => state.mainStateData);

  if (isEmpty(orderPaymentResult)) {
    return null;
  }

  return <PaymentResult
    widgetNameSpace={widgetNameSpace}
    trackingCallback={trackingCallback}
    orderPaymentResult={orderPaymentResult}
    orderInfo={orderInfo}
    confirmationMessage={confirmationMessage}
    locale={locale}
    orderDescription={confirmationMessage?.confirmationDescription || confirmationDescription }
    showFullInfoPaymentResult={showFullInfoPaymentResult}
    orderReviewModel={isPPF ? undefined : orderReviewModel} />;
};

PaymentResultContainer.propTypes = {
  trackingCallback: func,
};

PaymentResultContainer.defaultProps = {
  trackingCallback: noop,
};

export default memo(PaymentResultContainer);
